import { createAction, props } from "@ngrx/store";

const prefix = "[Team Member Name Filter]";

export const loadComponent = createAction(`${prefix} Load Component`);
export const unloadComponent = createAction(`${prefix} Unload Component`);
export const filterTeamMembersByName = createAction(
  `${prefix} Filter Team Members By Name`,
  props<{ filterString: string }>(),
);
